<template>
  <TresGroup>
    <DotsMap2LocationRing
      :show="hovering"
      render-order="20"
    />

    <TresMesh
      :material="material"
      :rotation="[MathUtils.degToRad(-90), 0, 0]"
      render-order="21"
    >
      <TresCircleGeometry :args="[0.0027, 32]" />
    </TresMesh>

    <!-- HIT AREA -->
    <TresMesh
      ref="refHover"
      :rotation="[MathUtils.degToRad(-90), 0, 0]"
      render-order="22"
    >
      <!-- <TresCircleGeometry :args="[0.0065, 32]" /> -->
      <TresCircleGeometry :args="[0.0034, 32]" />
      <TresMeshBasicMaterial
        color="red"
        :transparent="true"
        :opacity="0"
      />
    </TresMesh>

    <!-- <TresMesh
      :material="material"
      :rotation="[MathUtils.degToRad(-90), 0, 0]"
      ref="refRing1"
    >
      <TresRingGeometry :args="[0.005, 0.007, 32]" />
    </TresMesh> -->
  </TresGroup>
</template>

<script setup lang="ts">
import { MathUtils } from "three"
import dotsParams from "@/components/three/shaders/dotsParams.glsl?raw"
import * as helpers from "@/components/three/shaders/helpers.js"
import * as config from "@/components/three/config/dots-map"
import baseVertex from "@/components/three/shaders/base.vert?raw"

const props = defineProps({
  // geometry: {
  //   required: true,
  // },
  locationId: {
    required: true,
  },
  idx: {},
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refHover = ref(null)
const refRing1 = ref(null)
const hovering = useMeshHover(refHover)

// onMounted(() => {
//   $gsap.fromTo(
//     refRing1.value.scale,
//     { x: 1, y: 1 },
//     {
//       x: 2,
//       y: 2,
//       repeat: -1,
//     }
//   )
// })
watch(
  () => hovering.value,
  () => {
    $gsap.to(uniforms.uHovering, {
      value: hovering.value ? 1.0 : 0.0,
      duration: 0.3,
      ease: "power2.out",
    })

    if (hovering.value) {
      app.setHoverLocation(props.locationId)
    } else {
      app.setHoverLocation(null)
    }
  }
)

const dotsUniforms = await useDotsUniforms()

const uniforms = {
  uFlowMapStrength: { value: 0.3 },

  // AMBIENT
  uAmbientSpeed: { value: config.ambientSpeed },
  uAmbientScale: { value: config.ambientScale },
  uAmbientCutoff: { value: config.ambientCutoff },
  uAmbientStrength: { value: 0.01 },

  uHovering: { type: "f", value: 0.0 },
  uIdx: { value: props.idx },

  ...dotsUniforms,
}

// **********************************************************************
// FRAGMENT
// **********************************************************************
const fragmentShader = /*glsl*/ `

  ${dotsParams}

  uniform float uHovering;
  uniform float uIdx;

  void main() {

    vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
    vec3 color = vec3(1.0);

    // GRADIENT
    vec4 gradient = texture2D(tGradient, vUv);
    color *= gradient.rgb;


    color *= 1.0 + abs(cos(uTime + uIdx)) * 0.65;

    color *= mix(1.0, 3.0, uHovering);


    // MASK
    // float mask = 0.;

    // // NOISE
    // vec2 nuv = vec2(screenUv.x, screenUv.y);
    // vec2 uvNoise1 = vec2(nuv.x + uTime * uAmbientSpeed, nuv.y) * (1.0 / uAmbientScale);
    // vec2 uvNoise2  = vec2(nuv.x - uTime * uAmbientSpeed, nuv.y) * (1.0 / uAmbientScale);
    // vec4 noise1 = texture2D(tNoise, uvNoise1);
    // vec4 noise2 = texture2D(tNoise, uvNoise2);
    // mask += (smoothstep(0.5, 1.0, noise1.r) + smoothstep(uAmbientCutoff, 1.0, noise2.g)) ;

    // // FLOW MAP
    // vec4 flowMap = texture2D(tFlowMap, screenUv);
    // mask += smoothstep(0.5, 1.0, flowMap.b) * 0.5 * uFlowMapStrength;

    // COLOR
    // color *= clamp(mask, 0.0, 1.0); // mask

    // color = vec3(0.77, 0.88, 0.77);
    gl_FragColor = vec4(color, 1.0);


  }
`

// const material = new MeshBasicMaterial({
//   color: 0xff0000,
// })
const material = new ShaderMaterial({
  uniforms,
  vertexShader: baseVertex,
  fragmentShader,
  toneMapped: false,
  transparent: true,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
